import React, { useEffect, useState } from "react";
import "../Dashboard/Dashboard.css";
import { useDispatch } from "react-redux/es/exports";
import { toast } from "react-toastify";
import { useSelector } from "react-redux/es/exports";
import axiosinstances from "../../Helper/useAxios";
import { isSuperAdmin, isUserAdmin } from "../../utils/comman/Common";
import { useNavigate } from "react-router-dom";

const RefundStatus = () => {
  const [axiosInstance] = axiosinstances();
  const [file, setFile] = useState();
  const [array, setArray] = useState([]);
  const [csvLoaded, setCsvLoaded] = useState(false)
  const [dataLoading, setDataLoading] = useState(false)
  const [singleDataRefund, setSingleDataRefund] = useState(true)
  const [singleOrderId, setSingleOrderId] = useState('')
  const navigate = useNavigate();
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const e = JSON.parse(sessionStorage.getItem("token"));
  const dispatch = useDispatch();
  const fileReader = new FileReader();
  const handleOnChange = (e) => {
    setFile(e.target.files[0]);
  };
  const csvFileToArray = (string) => {
    const csvHeader = string.slice(0, string.indexOf("\n")).split(",");
    const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");
    var newArray=[]
    const array = csvRows.map((i) => {
      
      const values = i.split(",");
      const obj = csvHeader.reduce((object, header, index) => {
        object[header] = values[index];
        return object;
      }, {});
      if(obj?.orderId !== undefined && obj?.orderId !== null && obj?.orderId !== ''){
        newArray.push(obj)
        return obj;
      }
      
    });
    setArray(newArray);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    setCsvLoaded(true)
    if (file) {
      fileReader.onload = function (event) {
        const text = event.target.result;
        csvFileToArray(text);
      };

      fileReader.readAsText(file);
    }
  };

//   const headerKeys = Object.keys(Object.assign({}, ...array));
// //console.log('headerKeys', headerKeys)

const updateCsvStatus = async (orderId) => {
  
  const response = await  axiosInstance
  .get(`/api/v1/proxy/mobile/order/fail/order-id/${orderId}`, {
    headers: {
      Authorization: `Bearer ${e}`,
      "client-id": id,
      role: "ROLE_RETAILER_FINXPAY",
    },
  })
 .then((res) => {
  // console.log('resaaa', res)
  if(!singleDataRefund && res.status == 200){
    let tempArray =[...array]
    const index = tempArray.findIndex(objectIndex => {
      return objectIndex?.orderId === res?.data?.id;
    });
     tempArray[index].paymentStatus= res.data?.paymentStatus
     tempArray[index].status= res.data?.status
     setArray(tempArray)
  } else if(singleDataRefund && res.status == 200) {
    toast.success(`Successful refunded of id ${orderId}`)
  } else if(res?.response?.status !== undefined && res?.response?.status == 500){
    toast.error(`Something went wrong`); 
  }
  
 })
 .catch((err) => {
   //console.log(err);
   toast.error(`fail to refund of id ${orderId}`);
 });
  if (response) {
    const result = response.data.orders;

    if (result) {
    }

    return response.data;
  }
  return false;
};
async function updateStatus () {
  for (let i =0; i < array.length; i++) {
    updateCsvStatus(array[i].orderId)
    //console.log(i == array.length -1)
    if(i == array.length -1 ){
      setCsvLoaded(false)
    }
  }
}
useEffect(() => {
  if(array.length > 0 && csvLoaded){
    updateStatus()
  }
}, [array])

//console.log('csvLoaded',csvLoaded)

  return (
    <React.Fragment>
      { isSuperAdmin(id) && isUserAdmin(id) && (
        <div class="mid">
          <div class="container-fluid">
            <div class="maincard">
              <div class="tab-content" id="mobiletab">
                <div
                  class="tab-pane fade show active"
                  id="nav-mobi"
                  role="tabpanel"
                  aria-labelledby="mobile-tab"
                >
                  <div class="head">
                    {/* <h3>Refunded List</h3> */}
                    { !singleDataRefund ? <>
                    <button
                      class="btn"
                      type="button"
                      onClick={(e) => {
                        handleOnSubmit(e);
                      }}
                    >
                      Upload csv file
                    </button>
                    <div class="headsearch">
                      <div class="mb-3">
                        <input
                          class="form-control"
                          type={"file"}
                          id={"csvFileInput"}
                          accept={".csv"}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>
                    </> : <>
                    <button
                    class="btn"
                    type="button"
                    onClick={(e) => {
                      updateCsvStatus(singleOrderId)
                    }}
                    disabled={singleOrderId == ''}
                  >
                    submit Refund
                  </button>
                  <div class="headsearch">
                    <div class="mb-3">
                      <input
                        class="form-control"
                        type='text'
                        value={singleOrderId}
                        placeholder={'Enter order id'}
                        onChange={(e)=>setSingleOrderId(e.target.value)}
                      />
                    </div>
                  </div>
                  </>
}
                    {
                      !singleDataRefund ? 
                      <button
                      class="btn"
                      type="button"
                      style={{float:'left'}}
                      onClick={(e) => {
                        setSingleDataRefund(!singleDataRefund)
                      }}
                    >
                      Refund Single Item
                    </button> :  <button
                      class="btn"
                      type="button"
                      style={{float:'left'}}
                      onClick={(e) => {
                        setSingleDataRefund(!singleDataRefund); setSingleOrderId('')
                      }}
                    >
                      Refund Multiple Item
                    </button>
                    }
                   
                  </div>

                  <div class="txn-list" id="recntxn">
                  { array.length === 0 ? <p>Upload Refunded File</p> :<>
                  {array !== undefined && array?.map((data) => {
                    return (
                      <div class="txn-item" >
                        <div class="txn-head" id="txnhead1">
                          <div
                            class="collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#txn1"
                            aria-expanded="false"
                            aria-controls="txn1"
                          >
                            <div
                              class={`txncard ${
                                data.status === "ACTIVE"
                                  ? "success grbg"
                                  : `${
                                    data.status === "INACTIVE" ||
                                    data.status === "SUSPENDED" ||
                                    data.status === "FLAGGED" 
                                        ? "pending ylbg"
                                        : "failed rdbg"
                                    }`
                              }`}
                            >
                              <div class="row">
                                <div class="col-12 col-md-5">
                                  <div class="txntxt">
                                    <h5> Order ID: {data?.orderId}</h5>
                                  </div>
                                  <div class="txntxt">
                                    <h6>Mobile No.: {data?.mobile}</h6>
                                  </div>
                                </div>
                                {/* <div class="col-12 col-sm-5 col-lg-3">
                                  <div class="txntxt">
                                    <h6>Operator Id: {data?.operatorId}</h6>
                                  </div>
                                </div> */}

                                <div class="col-12 col-md-5">
                                  <div class="txntxt">
                                    <h6>Operator ID: {data?.operatorId}</h6>
                                    {/* <h6>Date and Time: <span> {data.createdOn
                                            .replace("T", " ")
                                            .slice(0, -4)} </span> </h6> */}
                                    {/* <h6>Amount: {data?.operatorId}</h6> */}
                                  </div>
                                  <div class="txntxt">
                                  <h5> Status: {data?.status !== undefined && data?.status !== null ? data?.status : 'updating status' }</h5>
                                  </div>
                                </div>
                                <div class="col-12 col-md-2">
                                  <div class="txntxt">
                                    <h4>
                                      ₹ {data?.paymentAmt}{" "}</h4>
                                      <h4>Payment status :
                                      <span
                                                  class={`${
                                                    data?.paymentStatus !== undefined
                                                      ? "success"
                                                      : "failed"
                                                        
                                                  }`}
                                                >
                                                   {data?.paymentStatus !== undefined && data.paymentStatus !== null ? data?.paymentStatus : "Wait updating"}
                                                </span>
                                        
                                     
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                       </div>
                    );
                  })}
                  
                  
                  {/* <div class="pager">
                    {
                      table !== undefined && table !== null && table.length > 0 && search == '' &&
                       <p>
                       Showing 1 to {table.length < 10 ? table.length : table.length} of { table !== undefined && table !== null && paginationDetails.totalPost} entries{" "}
                       <button class="lbbtn" type="button" onClick={onExportData}>
                         Export
                       </button>
                     </p>
                    }
                   
                    {
                      paginationDetails.totalPost !== undefined && paginationDetails.totalPost !== null && paginationDetails.totalPost > 10 && search == '' &&
                     <Pagination
                     className="pagination-bar"
                     currentPage={paginationDetails.currentPage}
                     totalCount={paginationDetails.totalPost}
                     pageSize={paginationDetails.postsPerPage}
                     onPageChange={page => 
                       handalpageclick(page)
                     }
                     />
                      // <Pagination  postsPerPage={paginationDetails.postsPerPage} totalPosts={table.length} paginate={paginate} currentPage={paginationDetails.currentPage} />
                     
                        }
                  </div> */}
                  </>}
                </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="mobi-grap"
                  role="tabpanel"
                  aria-labelledby="mobi-grap-tab"
                >
                  {/* <TransactionGraph/>  */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default RefundStatus;
